"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHashError = exports.parseResult = void 0;
function parseResult(response) {
    if (!response.result) {
        throw new Error('No response in GraphQL link.');
    }
    return JSON.parse(response.result);
}
exports.parseResult = parseResult;
function isHashError(result) {
    return isHashErrorFromNewGateway(result) || isHashErrorFromOldGateway(result);
}
exports.isHashError = isHashError;
function isHashErrorFromOldGateway(result) {
    var _a;
    return (_a = result.errors) === null || _a === void 0 ? void 0 : _a.some(error => error.message === 'Invalid Syntax');
}
function isHashErrorFromNewGateway(result) {
    var _a;
    return (_a = result.errors) === null || _a === void 0 ? void 0 : _a.some(error => { var _a; return ((_a = error.extensions) === null || _a === void 0 ? void 0 : _a.type) === 'hashNotFound'; });
}
//# sourceMappingURL=utils.js.map